import { render, staticRenderFns } from "./groups-page.vue?vue&type=template&id=26153d28&scoped=true&"
import script from "./groups-page.vue?vue&type=script&lang=js&"
export * from "./groups-page.vue?vue&type=script&lang=js&"
import style0 from "./groups-page.vue?vue&type=style&index=0&id=26153d28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26153d28",
  null
  
)

export default component.exports